import { Directive, HostListener, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { NgModel } from '@angular/forms';


@Directive({
  selector: '[defilement]'
})
export class DefilementDirective {
  @Input('range') _range: number;
  @Input('idsPhotos') _idsPhotos: string[];
  @Output('maj') majChiffres: EventEmitter<any> =  new EventEmitter<any>();

  constructor(private zone: ElementRef) { }

  @HostListener("mouseover") onmouseover() {
    if (this._range >= this._idsPhotos.length) {
      this._range = 3;
    } else {
      this._range++;
    }
    this.majChiffres.emit({'ids': this._idsPhotos.slice(this._range-3, this._range), 'range': this._range});
  }
}




// WEBPACK FOOTER //
// ./src/app/outils/defilement.directive.ts